import { FilledNewIconProps } from '@diritto/common/style/icon';
import { twMerge } from 'tailwind-merge';

export const RankingIcon = ({ fill, color, className }: FilledNewIconProps) =>
  fill ? (
    <svg
      className={twMerge('size-[26px]', className)}
      width="100%"
      height="100%"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 6H3V9C3 10.1046 3.89543 11 5 11V6ZM1 9C1 11.2091 2.79086 13 5 13C5 16.866 8.13401 20 12 20V22H7V24H12H14H19V22H14V20C17.866 20 21 16.866 21 13C23.2091 13 25 11.2091 25 9V4H21H19H7H5H1V9ZM21 6V11C22.1046 11 23 10.1046 23 9V6H21Z"
        fill={color}
      />
    </svg>
  ) : (
    <svg
      className={twMerge('size-[26px]', className)}
      width="100%"
      height="100%"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 6H3V9C3 10.1046 3.89543 11 5 11V6ZM1 9C1 11.2091 2.79086 13 5 13C5 16.866 8.13401 20 12 20V22H7V24H12H14H19V22H14V20C17.866 20 21 16.866 21 13C23.2091 13 25 11.2091 25 9V4H21H19H7H5H1V9ZM14 18C16.7614 18 19 15.7614 19 13V6H7V13C7 15.7614 9.23858 18 12 18H14ZM21 6V11C22.1046 11 23 10.1046 23 9V6H21Z"
        fill={color}
      />
    </svg>
  );
